export const columnsCalls = [
	{
		headerName: 'Дата',
		field: 'gdate',
		width: 350,
		sort: true,
	},
	/*{
        headerName: 'Сценарий',
        field: 'script',
        width: 250,
    },
    {
        headerName: 'Тип',
        field: 'type',
        width: 350,
    },*/
	{
		headerName: 'Телефон',
		field: 'msisdn',
		input: true,
		width: 250,
	},
	{
		headerName: 'Данные',
		field: 'data',
		input: true,
		width: 250,
	},
	{
		headerName: 'Статус',
		field: 'status',
		width: 300,
		select: true,
		selectValue: 'all',
		menuItem: [
			{ value: 'all', label: 'Все' },
			{ value: 'cancelled', label: 'отменен' },
			{ value: 'callFailed', label: 'ошибка' },
			{ value: 'start', label: 'запуск' },
			{ value: 'answered', label: 'отвечен' },
		],
	},
	{
		headerName: 'Длительность, сек.',
		field: 'duration',
		width: 250,
		sort: true,
	},
	{
		headerName: 'Файл',
		field: 'media',
		width: 250,
		// sort: true
	},
	{
		headerName: 'Результат',
		field: 'step',
		width: 300,
		select: true,
		selectValue: 'all',
		menuItem: [
			{ value: 'all', label: 'Все' },
			{ value: 'успешно', label: 'успешно' },
			{ value: 'не успешно', label: 'не успешно' },
		],
	},
];
